"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortStringByFieldAsc = exports.sortByString = exports.sortByOrder = exports.sortByNumber = exports.sortByNameAsc = exports.sortByName = exports.sortByFields = exports.sortByField = exports.sortByDueDate = exports.sortByDate = exports.sortByBoolean = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var sortByName = exports.sortByName = function sortByName(item1, item2, order) {
  return sortByField(item1, item2, order, "name");
};
var sortByOrder = exports.sortByOrder = function sortByOrder(item1, item2, order) {
  return sortByField(item1, item2, order, "order");
};
var sortByFields = exports.sortByFields = function sortByFields(item1, item2, fields) {
  if (fields && fields.length > 0) {
    var result = 0;
    fields.forEach(function (field) {
      if (result == 0) {
        var fieldName = field.name ? field.name : field;
        var fieldOrder = field.order;
        result = sortByField(item1, item2, fieldOrder, fieldName);
      }
    });
    return result;
  }
  return -1;
};
var sortByDueDate = exports.sortByDueDate = function sortByDueDate(item1, item2, order) {
  return sortByField(item1, item2, order, "dueAtTime");
};
var sortByField = exports.sortByField = function sortByField(item1, item2, order, field) {
  var value1 = field ? item1[field] : item1;
  var value2 = field ? item2[field] : item2;
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";
  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (_typeof(value1) != _typeof(value2)) return sortByString(_typeof(value1), _typeof(value2), order);
  if (typeof value1 == "boolean") return sortByBoolean(value1, value2, order);
  if (typeof value1 == "string") return sortByString(value1, value2, order);
  if (typeof value1 == "number") return sortByNumber(value1, value2, order);
  if (value1 instanceof Date) return sortByDate(value1, value2, order);
};
var sortByBoolean = exports.sortByBoolean = function sortByBoolean(value1, value2, order) {
  if (value1 == value2) return 0;
  var result = 1;
  if (order && order.toLowerCase() === "desc") result = -1;
  if (value1 && !value2) {
    return result;
  }
  if (!value1 && value2) {
    return -result;
  }
  return 0;
};
var sortByString = exports.sortByString = function sortByString(value1, value2, order) {
  if (value1 == undefined && value2 == undefined) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (value1.toLowerCase() == value2.toLowerCase()) return 0;
  var result = orderByDesc ? -1 : 1;
  return value1.toLowerCase() > value2.toLowerCase() ? result : -result;
};
var sortByNumber = exports.sortByNumber = function sortByNumber(value1, value2, order) {
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  var result = orderByDesc ? -1 : 1;
  return value1 > value2 ? result : -result;
};
var sortByDate = exports.sortByDate = function sortByDate(value1, value2, order) {
  if (value1 == value2) return 0;
  if (value1 instanceof Date && value2 instanceof Date) {
    if (value1.getTime() === value2.getTime()) return 0;
  }
  var orderByDesc = order && order.toLowerCase() === "desc";
  var result = orderByDesc ? -1 : 1;

  // believe that undefined is the lowest
  if (value1 == undefined) return -result;
  if (value2 == undefined) return result;
  return value1 > value2 ? result : -result;
};
var sortByNameAsc = exports.sortByNameAsc = function sortByNameAsc(a, b) {
  return sortByName(a, b, "asc");
};
var sortStringByFieldAsc = exports.sortStringByFieldAsc = function sortStringByFieldAsc(a, b, field) {
  return a[field] == "" || a[field].toLowerCase() > b[field].toLowerCase() ? 1 : -1;
};